<template>
  <div class="flex items-center ">
    <label id="listbox-label" class="block text-sm leading-5 font-medium mr-2 text-gray-500">
      <slot name="SelectLabel"></slot>
    </label>
    <div class="relative" v-click-outside="closeDropdown">
      <span class="inline-block w-full rounded-md">
        <button type="button"
        @click="openDropdown"
        aria-haspopup="listbox"
        aria-expanded="true"
        aria-labelledby="listbox-label"
        class="select-button">
          <div class="flex items-center space-x-3">
            <span class="block truncate">
              {{ value }}
            </span>
          </div>
          <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
            <svg
            class="h-5 w-5 text-gray-400"
            viewBox="0 0 20 20"
            fill="none"
            stroke="currentColor">
              <path d="M7 7l3-3 3 3m0 6l-3 3-3-3"
              stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round"/>
            </svg>
          </span>
        </button>
      </span>
      <!-- item -->
      <div
      v-show="isOpen"
      class="absolute mt-1 w-full rounded-md bg-white shadow-lg z-10">
        <ul
        tabindex="-1"
        role="listbox"
        aria-labelledby="listbox-label"
        aria-activedescendant="listbox-item-3"
        class="listbox">
          <li
          tabindex="0"
          @click="select(d)"
          id="listbox-item-0"
          role="option"
          v-for="d in data" :key="d"
          class="list-item">
            <div class="flex items-center space-x-3">
              <span
              class="block truncate"
              :class="{ 'font-normal' : !isSelected(d) , 'font-semibold' : isSelected(d)}">
                {{ d }}
              </span>
            </div>
            <!-- Checkmark -->
            <span
            v-show="isSelected(d)"
            class="absolute inset-y-0 right-0 flex items-center pr-4">
              <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414
                 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"/>
              </svg>
            </span>
          </li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside';

export default {
  name: 'Select',
  props: {
    data: Array,
    value: String,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    isSelected(value) {
      return this.value === value;
    },
    closeDropdown() {
      this.isOpen = false;
    },
    openDropdown() {
      this.isOpen = true;
    },
    select(value) {
      this.isOpen = false;
      this.$emit('valueSelect', value);
    },
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
};
</script>

<style lang="scss">
  .select-button {
    @apply cursor-pointer relative w-full rounded-md border-2
    border-gray-300 bg-white pl-3 pr-10 py-2 text-left
    transition ease-in-out duration-150 text-sm leading-5;
    &:focus {
      @apply outline-none border-primary-default;
    }
  }
  .listbox {
    @apply max-h-56 rounded-md py-1 text-sm leading-5 overflow-auto;
    &:focus {
      @apply outline-none;
    }
  }
  .list-item {
    @apply text-gray-900 select-none relative py-2 pl-3 pr-9 cursor-pointer;
    &:hover {
      @apply bg-gray-100;
    }
    &:focus {
      @apply outline-none bg-gray-100;
    }
  }
</style>
